import { RouterNavigationAction } from '@ngrx/router-store';
import { createAction, props, union } from '@ngrx/store';

import { Step } from '@fcom/common';
import { Cabin, FinnairAirBoundsChangeResponse, FinnairBoundItem, FinnairOrder } from '@fcom/dapi/api/models';
import { FlightTimeOption, FlightFilters } from '@fcom/common-booking/interfaces/flight-filters.interface';

import { TicketSelectionPhase } from '../../enums';
import { BoundSelection, NewBoundSelection } from '../../interfaces';

export const setLoading = createAction('[VoluntaryChange] setLoading', props<{ loading: boolean }>());
export const setShowDatepickerError = createAction(
  '[VoluntaryChange] setShowDatepickerError',
  props<{ showDatepickerError: boolean }>()
);
export const clearState = createAction('[VoluntaryChange] clearState');

export const setOrderChangeData = createAction(
  '[VoluntaryChange] SetOrderChangeData',
  props<{ orderChange: FinnairOrder }>()
);
export const clearOrderChangeData = createAction('[VoluntaryChange] clearOrderChangeData');

export const setTicketSelectionPhase = createAction(
  '[VoluntaryChange] setTicketSelectionPhase',
  props<{ phase: TicketSelectionPhase }>()
);
export const setDirectFlights = createAction('[VoluntaryChange] setDirectFlights', props<{ directFlights: boolean }>());
export const setDepartureBoundSelection = createAction(
  '[VoluntaryChange] setDepartureBoundSelection',
  props<{ departureBound: BoundSelection }>()
);
export const setReturnBoundSelection = createAction(
  '[VoluntaryChange] setReturnBoundSelection',
  props<{ returnBound: BoundSelection }>()
);
export const setBoundChange = createAction(
  '[VoluntaryChange] setBoundChange',
  props<{ boundId: string; boundChange: FinnairAirBoundsChangeResponse }>()
);
export const clearBoundChange = createAction('[VoluntaryChange] clearBoundChange', props<{ boundId: string }>());
export const clearDepartureBoundSelection = createAction('[VoluntaryChange] clearDepartureBoundSelection');
export const clearReturnBoundSelection = createAction('[VoluntaryChange] clearReturnBoundSelection');
export const setNewDeparture = createAction(
  '[VoluntaryChange] setNewDeparture',
  props<{ newDeparture: NewBoundSelection }>()
);
export const setNewReturn = createAction(
  '[VoluntaryChange] setNewReturnBoundId',
  props<{ newReturn: NewBoundSelection }>()
);

export const setStopsCount = createAction('[VoluntaryChange] setStopsCount', props<{ stopsCount: number }>());
export const resetStopsCount = createAction('[VoluntaryChange], resetStopsCount');

export const setCabin = createAction('[VoluntaryChange], setCabin', props<{ cabin: Cabin }>());
export const resetCabin = createAction('[VoluntaryChange], resetCabin');

export const setDepartureTime = createAction(
  '[VoluntaryChange], SetDepartureTime',
  props<{ departureTime: FlightTimeOption[] }>()
);
export const resetDepartureTime = createAction('[VoluntaryChange], ResetDepartureTime');

export const setArrivalTime = createAction(
  '[VoluntaryChange], SetArrivalTime',
  props<{ arrivalTime: FlightTimeOption[] }>()
);
export const resetArrivalTime = createAction('[VoluntaryChange], ResetArrivalTime');

export const setAllFilters = createAction('[VoluntaryChange], SetAllFilters', props<{ filters: FlightFilters }>());
export const resetAllFilters = createAction('[VoluntaryChange], ResetAllFilters');

export const setTempDeparture = createAction(
  '[VoluntaryChange] setTempDeparture',
  props<{ tempDeparture: FinnairBoundItem }>()
);
export const setTempReturn = createAction('[VoluntaryChange] setTempReturn', props<{ tempReturn: FinnairBoundItem }>());

export const setStep = createAction('[VoluntaryChange] setStep', props<{ step: Step; skipRouteChange?: boolean }>());

const all = union({
  setLoading,
  setShowDatepickerError,
  clearState,
  setTicketSelectionPhase,
  setDirectFlights,
  setDepartureBoundSelection,
  setReturnBoundSelection,
  setBoundChange,
  setStep,
  setNewDeparture,
  setNewReturn,
  setTempDeparture,
  setTempReturn,
  clearBoundChange,
  clearDepartureBoundSelection,
  clearReturnBoundSelection,
  setOrderChangeData,
  clearOrderChangeData,
  setStopsCount,
  resetStopsCount,
  setCabin,
  resetCabin,
  setDepartureTime,
  resetDepartureTime,
  setArrivalTime,
  resetArrivalTime,
  resetAllFilters,
});

export type StateActionsUnion = typeof all | RouterNavigationAction;
